<template>
  <div v-if="pageItem.Download && pageItem.Download.length > 0" class="py-0">
    <v-container fluid class="downloads">
    <v-container class="py-0">
    <h2>Downloads</h2>
    <div>
    <v-row class="pt-10">
    <v-col cols='12' sm="6" lg="4" class="pb-7" v-for="(download, index) in pageItem.Download" :key="index">

        <v-row v-if="download.Path && download.Description && download.Title">
          <v-col cols='3' class="py-0">
            <img v-if="download.ThumbNail"
          :src="download.ThumbNail"
          :alt="download.ThumbNailAltText"
          class="cover"
          width="100%"

        />

          </v-col>
          <v-col cols='9' class="py-0 pl-4">
            <h3 class="pt-0">{{ download.Title }}</h3>
        <p class="pb-0">{{ download.Description }}</p>
        <p v-if="download.NumberOfPages" style="font-size: 0.9rem;">Aantal pagina's: {{ download.NumberOfPages }}</p>
        <v-btn size='small' class="text-none text-decoration-none" href="#" @click="downloadFile(download.Path)">Download bestand</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>

  </v-container>
</v-container>


  </div>
</template>
<script setup>
const dataAll = useDataAll();
const { $downloads } = useNuxtApp()
const props = defineProps({
  pageItem: {
    type: Object,
    default: () => ({}),
  },

});


async function downloadFile(path) {

    await $downloads.downloadPage(path,props.pageItem.Code, true)
}


</script>
